export enum CpDialogSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL = 'full',
}

export type CpDialogConfig<InputComponentData> = {
  usePOC?: boolean; // @TODO remove after POC mode is over

  data?: InputComponentData;

  /**
    variations: `small` | `medium` | `large` | `full`

    Default = `small`.
  */
  size?: CpDialogSizes | string;

  /**
   * css classes used to modify the dialog look
   */
  extraClasses?: string;

  /**
    Whether the user can use escape key or click on the backdrop to close the modal.

    Default = `false`.

    If true, the the close button is also removed
  */
  disableClose?: boolean;

  /**
    Whether the user can click on the backdrop to close the modal.

    Default = `false`.

    @NOTE This is only useful if "disableClose" = `false`
  */
  overlayClose?: boolean;

  /**
    Provide a way to dynamically control modal closing process.

    Useful, if you want to prevent the modal from closing, once it has already been opened.

    Use-case: esign modal

    @NOTE This is only useful if "disableClose" = `false`
  */
  closeEvent?: (ev: Event) => void;
};

export const CP_DIALOG_DEFAULT_CONFIG = {
  data: {},
  size: CpDialogSizes.SMALL,
  extraClasses: '',
  disableClose: false,
  overlayClose: false,
};
